import { notifyBuilder } from "~/components/RequestCreationModal/Uploader/utils";
import { useCallback, useState } from "react";
import { XHRUpload } from "~/components/RequestCreationModal/Uploader/XHRUpload";
import { ProcessingFile, SelectedFile } from "~/components/RequestCreationModal/Uploader/types";
import Request, { File } from "~/services/request";



const stillProcessingUpload = (e) => {
    e.returnValue = "Ainda estamos processando o arquivo";
};

const useRequestCreatoionStats = () => {
    const notify = notifyBuilder(() => Promise.resolve());

    const [fileToUpload, setFileToUpload] = useState<Record<string, ProcessingFile>>({});
    const [xhrUploadHandle, setXhrUploadHandle] = useState({});
    const [curentRequestId, setCurrentRequestId] = useState<number>(null);

    const onSuccess = async () => {
        // no use
    };

    const onError = (e, file) => {
        console.log(e, file);
        // console.log("onError", e, file);
        return Promise.resolve();
    };

    const getPreSignData = useCallback( async (file: SelectedFile, requestId?: number) => {
        const maxLength = file.size;
        const filename = file.name.replace(/\s+/g, "").split(".").shift();
        const ext = file.name.split(".").pop();
        const key = `requests/${requestId}/${filename}.${ext}`;
        return Request.attachmentSing({ key, maxLength }).then((res) => res);
    }, [])

    const onComplete = useCallback(async (files: ProcessingFile[]) => {
        const filenames: File[] = files
            .filter((item) => item.status === "uploaded")
            .map((item) => {
                const parts = item.key.split("/");

                return {
                    requestId: parseInt(parts[1]),
                    filePath: item.key,
                };
            });

        return Request.attachmentRegister(filenames).then(() => {
            return files.reduce((acc, f) => {
                acc[f.file.name] = { status: "success" };
                return acc;
            }, {});
        });
    }, []);

    const onAfterSuccess = async () => {
        // no use
    };

    const performUpload = useCallback(
        async (fileDescripor:ProcessingFile, requestId:number) => {
            if (!fileDescripor || !requestId) {
                return;
            }

            notify({ type: "info", action: "beforeGetPresignedUrl", detail: { fileDescripor } });

            window.addEventListener("beforeunload", stillProcessingUpload);

            const { file } = fileDescripor;

            try {
                const preSignedData = await getPreSignData(file, requestId);

                if (!preSignedData) {
                    return;
                }

                const { fields } = preSignedData;

                notify({ type: "info", action: "presignedUrlAcquired", detail: { file, preSignedData } });

                const xhrUpload = new XHRUpload(preSignedData, file, setFileToUpload);
                setXhrUploadHandle((data) => ({ ...data, [file.name]: xhrUpload }));

                notify({ type: "info", action: "startingUpload", detail: { preSignedData, file } });

                const event = await xhrUpload.start();

                if (event === "abort") {
                    notify({ type: "info", action: "uploadAborted", detail: { file } });
                    return;
                }

                setFileToUpload((data) => ({
                    ...data,
                    [file.name]: { file, status: "uploaded", key: fields?.key },
                }));
                notify({ type: "info", action: "uploadSuccess", detail: { file } });

            } catch (e) {
                console.log("Erro no upload: ", e);
                notify({ type: "error", action: "uploadFailed", detail: { message: e.message, error: e } });
                setFileToUpload((data) => ({
                    ...data,
                    [file.name]: { file, status: "error", message: e?.message },
                }));
                onError(e, file);
            } finally {
                window.removeEventListener("beforeunload", stillProcessingUpload);
            }
        },
        [getPreSignData, notify, onError, onComplete]
    );

    const abortUpload = (key: string) => {
        window.removeEventListener("beforeunload", stillProcessingUpload);

        if (xhrUploadHandle?.[key]) {
            xhrUploadHandle[key].abort();
        }

        setFileToUpload((data) => {
            return Object.keys(data).reduce((acc, currentKey) => {
                if (key === currentKey) {
                    return acc;
                }

                acc[currentKey] = data[currentKey];
                return acc;
            }, {});
        });
    };

    const tryAgain = async (key: string) => {
        const file: ProcessingFile = { file: fileToUpload[key].file, status: "pending", uploaded: 0, uploadPercent: 0 };
        setFileToUpload((data) => ({ ...data, [file.file.name]: file }));
        await performUpload(file, curentRequestId);
    };

    const startUploading = async (requestId: number) => {
        const files = Object.values(fileToUpload);

        for (const file of files) {
            if (file.status !== "pending") {
                continue;
            }

            await performUpload(file, requestId);
            await new Promise(resolve => setTimeout(resolve, 3));
        }
    };


    return {
        tryAgain,
        onComplete,
        onSuccess,
        onError,
        setFileToUpload,
        fileToUpload,
        abortUpload,
        setCurrentRequestId,
        startUploading,
        getPreSignData,
        onAfterSuccess,
    };
};

export default useRequestCreatoionStats;
